import { useCallback } from 'react';
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { SvgIcon } from '@mui/material';
import { app } from 'router/routes';
import { useNavigate } from 'react-router-dom';

const useHeaderBtns = () => {
    const navigate = useNavigate()

    const goCreateUser = useCallback(() => {
        navigate(app.createUser)
    }, [])

    const headerBtns = [
        {
            id: 1,
            icon: <SvgIcon fontSize='small' component={AddIcon} inheritViewBox />,
            label: "משתמש חדש",
            action: goCreateUser,
            height: "35px",
            size:"small"
        }
    ]

    return headerBtns
}

export default useHeaderBtns